import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom'
import './../../resources/static/favicon.ico';


ReactDOM.render(
    (  
        <HashRouter>
            <App />
        </HashRouter>
    ),

    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/main/resources/js/index.js